import type { CSSProperties } from "react"

interface ConfirmationScreenProps {
  styles: Record<string, CSSProperties>
  confirmationTitle: string
  confirmationMessage?: string
  confirmationButtonText?: string
  onButtonClick: () => void
}

export default function ConfirmationScreen({
  styles,
  confirmationTitle,
  confirmationMessage,
  confirmationButtonText,
  onButtonClick,
}: ConfirmationScreenProps) {
  const showButton = Boolean(confirmationButtonText?.trim())

  return (
    <>
      <h1 id="form-popup-confirmation-title" style={styles.confirmationTitle}>
        {confirmationTitle}
      </h1>
      {confirmationMessage?.trim() ? (
        <p id="form-popup-confirmation-message" style={styles.confirmationMessage}>
          {confirmationMessage}
        </p>
      ) : null}
      {showButton ? (
        <button
          id="form-popup-confirmation-button"
          type="button"
          style={styles.confirmationButton}
          onClick={onButtonClick}
        >
          {confirmationButtonText}
        </button>
      ) : null}
    </>
  )
}
